import React from 'react';
import Select from 'react-select';
import { useDispatch, useSelector } from 'react-redux';
import { setEventType } from '../../../../../store/actions/sportEvents';
import { EVENT_TYPES } from '../../../../../constants/defaultValues';

const EventType = () => {
    const dispatch = useDispatch();

    const selectedEventType = useSelector(state => state.sportEvents.eventType);

    const onChange = eventType => {
        dispatch(setEventType(eventType));
    };

    return (
        <Select
            className='common-select common-select--events'
            classNamePrefix='common'
            menuPlacement={'auto'}
            isSearchable={false}
            value={selectedEventType}
            onChange={onChange}
            options={EVENT_TYPES}
        />
    );
};

export default EventType;
